export default "__VITE_ASSET__2c8a3850__"